import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { VStack } from "@whoosh/design-system/src/components/primitive";
import { PackageBenefitsSummary } from "@whoosh/features/src/Packages";

import { StorePackageSummary } from "./StorePackageSummary";
import { StorePackageDetail_package$key } from "./__generated__/StorePackageDetail_package.graphql";

type Props = {
  packageRef?: StorePackageDetail_package$key | null;
};
export const StorePackageDetail = ({ packageRef }: Props) => {
  const pkg = useFragment(StorePackageDetailFragmentString, packageRef);

  return (
    <VStack px={6} gap={6}>
      <PackageBenefitsSummary packageRef={pkg} />
      <StorePackageSummary packageRef={pkg} />
    </VStack>
  );
};

const StorePackageDetailFragmentString = graphql`
  fragment StorePackageDetail_package on Package {
    ...PackageBenefitsSummary_package
    ...StorePackageSummary_package
    id
  }
`;
